import { lazyForPaint } from 'react-loosely-lazy';
import { withAsync } from '@atlassian/help-center-common-component/with-async';

export const RequestDetailsMainSectionModule = withAsync({
    loader: lazyForPaint(
        () => import(/* webpackChunkName: "forge-request-details-main-section" */ './request-details-main-section')
    ),
    LoadingSkeleton: () => null,
});

export { Headline } from './request-details-main-section';
